import { Button } from 'components';
import React, { memo, MouseEventHandler } from 'react';

import * as Styles from './styles';

type TState = 'edit' | 'save';

interface IProps {
  state: TState;
  saveLabel?: string;
  editLabel?: string;
  deleteLabel?: string;
  deleteOnSaveStep?: boolean;
  labelDeleteOnSave?: string;
  onClickEdit?: MouseEventHandler<HTMLButtonElement>;
  onClickDelete?: MouseEventHandler<HTMLButtonElement>;
  onClickSave?: MouseEventHandler<HTMLButtonElement>;
  onClickCancel?: MouseEventHandler<HTMLButtonElement>;
  onClickDeleteOnSave?: MouseEventHandler<HTMLButtonElement>;
}

const FormFooterComponent: React.FC<IProps> = ({
  state,
  saveLabel = 'Salvar',
  editLabel = 'Editar',
  deleteLabel = 'Excluir',
  deleteOnSaveStep,
  labelDeleteOnSave,
  onClickEdit,
  onClickDelete,
  onClickSave,
  onClickCancel,
  onClickDeleteOnSave,
}) => {
  return (
    <Styles.Container>
      {state === 'edit' ? (
        <>
          <Button
            onClick={onClickEdit}
            outline
            leftIcon={{ name: 'pencil', marginRight: 'inherit' }}
          >
            {editLabel}
          </Button>

          <Button
            variant="danger"
            outline
            leftIcon={{ name: 'delete', size: 1.2, marginRight: 'inherit' }}
            onClick={onClickDelete}
          >
            {deleteLabel}
          </Button>
        </>
      ) : (
        <>
          {deleteOnSaveStep && (
            <Button
              variant="danger"
              outline
              leftIcon={{ name: 'delete', size: 1.2, marginRight: 'inherit' }}
              onClick={onClickDeleteOnSave || onClickDelete}
            >
              {labelDeleteOnSave || deleteLabel}
            </Button>
          )}

          <Button variant="cancel" ml="auto" onClick={onClickCancel}>
            Cancelar
          </Button>

          <Button type="submit" onClick={onClickSave}>
            {saveLabel}
          </Button>
        </>
      )}
    </Styles.Container>
  );
};

export const FormFooter = memo(FormFooterComponent);
